<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="6">
                <b-card>
                    <div slot="header">
                        {{Core.Definition.getDefinition('Google Calendar API')}}<br/>
                        <small>
                            {{Core.Definition.getDefinition('Autoriser Perfoplanning à créer des événements à votre calendrier Google')}}
                        </small>
                    </div>
                    <b-row>
                        <b-col>
                            <b-alert show variant="light">
                                {{Core.Definition.getDefinition('Connectez votre compte Google Calendar à Perfoplanning afin de synchroniser votre calendrier avec vos réservations.')}}
                            </b-alert>
                            <b-button @click="gotoGoogleAuth" class="btn btn-light">{{Core.Definition.getDefinition('Google Authentification')}}</b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: 'UserSettingsExternalServices',
        components: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        methods: {
            gotoGoogleAuth() {
                window.open(Core.Session.googleClient.authURL, '_blank')
            }
        }
    }
</script>
